"use client"

import React, {useEffect, useState} from 'react';
import {getFirstURISegment} from "@/utility/uriSegment.utility";
import Breadcrumbs from "@/components/common/BreadCrumb";
import PageHeader from "@/components/common/page-header";

function Page({params}) {
    const [url, setUrl] = useState(null);
    useEffect(() => {
        let url = getFirstURISegment() + "/" + params.post;
        setUrl(url)
    }, [])
    const paths = [{name: "TRANG CHỦ", url: "/"}, {name: "BẢNG GIÁ"}];
    return (
        <>
            <PageHeader title="Bảng giá" />
            <div className="container-fluid" style={{marginTop: "20px"}}>
                <Breadcrumbs paths={paths}/>
            </div>
        </>
    );
}

export default Page;